import React from "react"
import Features from "./features.module.scss"
import text from "../styles/typography.module.scss"
import FeatherIcon from "feather-icons-react"

export default function features(props) {
  return (
    <div className={Features.parent}>
      <div className={Features.layout}>
        <div className={Features.top}>
          <h3 className={text.heading2}>{props.title}</h3>
          <div className="iconContainer">
            <FeatherIcon icon={props.feather} />
          </div>
        </div>
        <div className={Features.bot}>
          <p className={text.paragraph}>{props.text}</p>
        </div>
      </div>
    </div>
  )
}
